import { Card, Badge, Tab, Tabs } from 'react-bootstrap';
import '../../../B2BBuyerSeller/B2BProfile/MyMeetingRequest/myMeetingRequest.css';
import CommProfileHeader from '../../../Exhibitor/Profile/CommProfileHeader';
import { useGetOtherCompanySlotRequestedList } from '../../../B2BBuyerSeller/apiEndpoints/b2bBuyerSellerEndpoint';
import MyMeetingRequestComm from '../../../B2BBuyerSeller/B2BProfile/MyMeetingRequest/MyMeetingRequestComm';
import { useExhibitorAuthContext } from '../../../../Context/AuthContex/ExhibitorAuthContext';
import { useSearchParams } from 'react-router-dom';

const MeetingManageMent = () => {
  const {
    state: { exhibitorUser },
    dispatch: authDispatch,
  } = useExhibitorAuthContext();

  const [searchParams] = useSearchParams();
  const slot_id = searchParams.get('slot_id');
  const { data } = useGetOtherCompanySlotRequestedList({
    type: 'Exhibitor',
    user_id: Number(exhibitorUser?.user_fair_member_id),
    slot_id: slot_id as string,
  });

  const pendingData = data?.data?.filter((r) => r?.status === 'Pending');
  const approvedData = data?.data?.filter((r) => r?.status === 'Accepted');
  const rejectedData = data?.data?.filter((r) => r?.status === 'Rejected');
  return (
    <>
      <CommProfileHeader
        listHeadingTitle='Received Meeting Request List'
        notShowingRightSide={true}
      />
      <div className='slot-requests-container profile-right-side'>
        {data?.data?.length === 0 ? (
          <Card className='text-center p-4 no-slots-card'>
            <p className='text-muted'>Meeting Requested Not Found</p>
          </Card>
        ) : (
          <Tabs defaultActiveKey='pending' className='mb-4'>
            <Tab
              eventKey='pending'
              title={
                <>
                  Pending{' '}
                  <Badge bg='warning' pill>
                    {pendingData?.length}
                  </Badge>
                </>
              }
            >
              <MyMeetingRequestComm
                showApprove
                showRejected
                self='from'
                data={pendingData}
              />
            </Tab>

            <Tab
              eventKey='approved'
              title={
                <>
                  Approved{' '}
                  <Badge bg='success' pill>
                    {approvedData?.length}
                  </Badge>
                </>
              }
            >
              <MyMeetingRequestComm self='from' data={approvedData} />
            </Tab>

            <Tab
              eventKey='rejected'
              title={
                <>
                  Rejected{' '}
                  <Badge bg='danger' pill>
                    {rejectedData?.length}
                  </Badge>
                </>
              }
            >
              <MyMeetingRequestComm self='from' data={rejectedData} />
            </Tab>
          </Tabs>
        )}
      </div>
    </>
  );
};

export default MeetingManageMent;
